'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var instance = _axios2.default.create({
  baseURL: 'https://apigw.olx.com.br',
  headers: {
    common: {
      'X-OLX-TEAM-KEY': '5XzjuCgmYE7qMlYpsLZbTvm98ik4CS4a'
    },
    post: {
      'Content-Type': 'application/json'
    }
  },
  withCredentials: true,
  timeout: 10000
});

exports.default = instance;